import { Construction } from "lucide-react";
import { PageHeader, Callout } from "@/components/common/PageHeader";

export default function StagePlaceholder({ title, stage, description }) {
  return (
    <div data-testid={`stage-placeholder-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
      <PageHeader title={title} description={description} />
      <div className="tqi-card p-10 text-center">
        <Construction className="mx-auto h-10 w-10 text-slate-300" />
        <div className="mt-3 text-lg font-bold text-[#101C47]">{stage ? `Planned for Stage ${stage}` : "Not available"}</div>
        <p className="mx-auto mt-2 max-w-xl text-sm text-slate-600">{stage ? "This section is not built yet. No numbers are shown here because none have been calculated — nothing on this screen is mocked or sampled." : "You do not have access to this section."}</p>
      </div>
      {stage && <div className="mt-4"><Callout tone="neutral" title="Status: Unavailable">Metrics for this section will display their reporting period, source freshness, definition and supporting records once the stage is implemented and tested.</Callout></div>}
    </div>
  );
}
